import type * as lazyFunctions from './lazyFunctions';
import { markFunction } from 'owa-performance';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule<typeof lazyFunctions>(
    () => import(/* webpackChunkName: "AppBootMetaOs" */ './lazyFunctions'),
    { name: 'AppBootMetaOs' }
);

export const lazyInitializeMetaOsAppSdkProxy: LazyAction<
    () => Promise<void>,
    LazyBootModule<typeof lazyFunctions>
> = new LazyAction(lazyModule, m =>
    markFunction(
        m.lazyInitializeMetaOsAppSdk.importAndExecute,
        'MetaOSPlatformAppBootImportAndExecuteScript'
    )
);

export const lazyGetOwaAuthTokenFromMetaOsHubProxy: LazyAction<
    typeof lazyFunctions.lazyGetOwaAuthTokenFromMetaOsHub.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyGetOwaAuthTokenFromMetaOsHub.importAndExecute);

export const lazyInitializeMetaOsCapabilitiesProxy: LazyAction<
    typeof lazyFunctions.lazyInitializeMetaOsCapabilities.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyInitializeMetaOsCapabilities.importAndExecute);

export const lazyGetContextProxy: LazyAction<
    typeof lazyFunctions.lazyGetContext.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyGetContext.importAndExecute);

export const lazyRegisterOnLoadHandlerProxy: LazyAction<
    typeof lazyFunctions.lazyRegisterOnLoadHandler.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyRegisterOnLoadHandler.importAndExecute);

export const lazyRegisterBeforeUnloadHandlerProxy: LazyAction<
    typeof lazyFunctions.lazyRegisterBeforeUnloadHandler.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyRegisterBeforeUnloadHandler.importAndExecute);

export const lazyGetOwaDecodedAuthTokenFromMetaOsHubProxy: LazyAction<
    typeof lazyFunctions.lazyGetOwaDecodedAuthTokenFromMetaOsHub.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyGetOwaDecodedAuthTokenFromMetaOsHub.importAndExecute);

export const lazyPreInitOwaAccountSourceListStoreProxy: LazyAction<
    typeof lazyFunctions.lazyPreInitOwaAccountSourceListStore.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyPreInitOwaAccountSourceListStore.importAndExecute);

export const lazyGetAccountServiceConfigProxy: LazyAction<
    typeof lazyFunctions.lazyGetAccountServiceConfig.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyGetAccountServiceConfig.importAndExecute);

export const lazyNotifyAppLoadedProxy: LazyAction<
    typeof lazyFunctions.lazyNotifyAppLoaded.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyNotifyAppLoaded.importAndExecute);

export const lazyIsNAAChannelRecommendedProxy: LazyAction<
    typeof lazyFunctions.lazyIsNAAChannelRecommended.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyIsNAAChannelRecommended.importAndExecute);
